<template>
  <main class="w-full flex flex-col justify-start items-center">


    <div class="w-full flex flex-col justify-start items-center">
      <div :class="preferenceStore.showRightPanel ? 'mt-8 mb-12' : 'mt-8 my-4'" class="w-full">
        <div class="w-full relative flex flex-col justify-start items-center rounded-xl">

          <div class="w-full relative flex justify-center items-center">
            <div class="w-full rounded-xl overflow-hidden flex justify-center items-center relative"
              :class="[!preferenceStore.showRightPanel ? 'max-h-0' : 'max-h-[200px] hover:mb-[3rem] hover:max-h-96 duration-300 border border-white/20 ']">
              <img v-if="projectData?.info?.project_banner" :src="projectData?.info?.project_banner"
                class="h-full object-contain rounded-xl brightness-50 hover:scale-125 duration-300 hover:brightness-100" />
              <div v-else class="w-full h-[200px] skeleton"></div>
            </div>

            <div class="w-full absolute bottom-0"
              :class="[preferenceStore.showRightPanel ? 'translate-y-[4rem]' : 'translate-y-[3rem]']">
              <div class="w-full flex justify-end items-center">
                <button @click="preferenceStore.showRightPanel = !preferenceStore.showRightPanel"
                  :class="[preferenceStore.showRightPanel ? 'text-white' : 'bg-turquoise-500 text-turquoise-1000 font-semibold']"
                  class="px-6 py-3 hover:bg-turquoise-500/10 hover:text-turquoise-500 border border-white/20 rounded-full duration-200 flex-shrink-0">{{
                    preferenceStore.showRightPanel ? "Hide" : "Show"
                  }} Info</button>
              </div>
            </div>
          </div>

          <div
            :class="[preferenceStore.showRightPanel ? 'flex-col justify-center items-center' : 'justify-start items-center space-x-4']"
            class="w-full relative z-20 flex pointer-events-none">
            <div
              :class="[preferenceStore.showRightPanel ? 'sm:w-[10rem] sm:h-[10rem] sm:-mt-[5rem] w-32 h-32 -mt-16 overflow-hidden sm:p-4 p-3 bg-white/20 backdrop-blur-lg rounded-full' : 'w-12 h-12 border border-white/20 rounded-md p-1 bg-white/10']"
              class=" ">
              <img v-if="projectData?.info?.project_logo" :src="projectData?.info?.project_logo"
                class="w-full h-full object-cover" :class="[preferenceStore.showRightPanel ? 'rounded-full' : '']"
                alt="" />
              <div v-else class="w-full h-full rounded-full skeleton"></div>
            </div>

            <div :class="[preferenceStore.showRightPanel ? 'w-full flex flex-col justify-center items-center' : '']">
              <h1
                :class="[preferenceStore.showRightPanel ? 'sm:text-3xl sm:my-2 text-2xl my-1' : 'sm:text-2xl text-xl']"
                class="text-white">{{ projectData?.info?.project_name }}
              </h1>
              <p v-if="preferenceStore.showRightPanel"
                class="leading-7 text-zinc-500 w-full h-full text-center sm:text-base sm:px-12 px-6 text-sm">
                {{ projectData?.info?.project_description }}</p>
            </div>
          </div>

          <div v-if="preferenceStore.showRightPanel" class="sm:hidden w-full space-y-8">
            <ProjectLinks :links="projectData?.info?.project_links"></ProjectLinks>
            <ProjectIntel :projectData="projectData"></ProjectIntel>
          </div>

        </div>
      </div>

      <div class="w-full flex justify-center items-start">


        <div class="w-full overflow-hidden flex flex-col justify-start items-center">

          <div class="w-full flex justify-between items-center my-4 border border-woodsmoke-700 rounded-md p-4"
            v-if="solanaAddress">

            <div>
              <strong>Connected</strong>
              <p class="text-sm">{{ solanaAddress.substring(0, 6) }}...{{
                solanaAddress.substring(solanaAddress.length - 6) }}
              </p>
            </div>

            <button @click="disconnectSolana()" class="btn sm:btn-md btn-sm text-red-500">Disconnect</button>
          </div>

          <div class="w-full flex justify-between items-center mb-8 ">
            <div class="w-full flex justify-start items-center sm:gap-4 gap-2 flex-wrap text-zinc-500 overflow-x-scroll">
              <button @click="selectTab(tab.key)" v-for="tab in tabs"
                class="sm:px-6 sm:py-3 px-3 py-1.5 text-sm sm:text-base hover:bg-turquoise-500/10 hover:text-turquoise-500 border rounded-full duration-200"
                :class="[tab.selected ? 'bg-turquoise-500/10  border-turquoise-500/20 text-turquoise-500' : 'border-transparent']">{{
                  tab.label }}</button>
            </div>
          </div>

          <section class="w-full flex-col flex justify-center items-center">

            <template v-if="solanaAddress">

              <template v-if="selectedTabKey == 'contribute'">
                <div class="w-full flex flex-col justify-start items-center gap-4">
                  <template v-for="blink in computedBlinks.contribute">
                    <web3-frame :url="`${blink.url}&solana_address=${solanaAddress}`" />
                  </template>
                </div>
              </template>

              <template v-if="selectedTabKey == 'vesting'">
                <div class="w-full flex flex-col justify-start items-center gap-4">
                  <template v-for="blink in computedBlinks.vesting">
                    <web3-frame :url="`${blink.url}&solana_address=${solanaAddress}`" />
                  </template>
                </div>
              </template>

              <template v-if="selectedTabKey == 'refund'">
                <div class="w-full flex flex-col justify-start items-center gap-4">
                  <template v-for="blink in computedBlinks.refund">
                    <web3-frame :url="`${blink.url}&solana_address=${solanaAddress}`" />
                  </template>
                </div>
              </template>

              <template v-if="selectedTabKey == 'immunity'">
                <div class="w-full flex flex-col justify-start items-center gap-4">
                  <template v-for="blink in computedBlinks.immunity">
                    <web3-frame :url="`${blink.url}&solana_address=${solanaAddress}`" />
                  </template>
                </div>
              </template>

            </template>

            <template v-else>
              <div class="w-full flex justify-center items-center flex-col py-24 space-y-8">

                <h2>Connect Wallet to Proceed</h2>

                <button @click="connectSolana()"
                  class="btn bg-turquoise-500 text-turquoise-1000 border-none hover:text-white">Connect
                  Phantom</button>

              </div>
            </template>


          </section>

        </div>

        <div
          :class="[preferenceStore.showRightPanel ? 'max-w-[300px] ml-8' : 'max-w-0', 'w-full flex-shrink-0 space-y-8 duration-300 overflow-hidden sm:block hidden']">
          <ProjectLinks :links="projectData?.info?.project_links"></ProjectLinks>
          <ProjectIntel :projectData="projectData"></ProjectIntel>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>

import { usePreferenceStore } from "~/stores/preference";
const preferenceStore = usePreferenceStore();

import { gql } from "@apollo/client/core";
import { queryNoCache } from "~/apollo";

const route = useRoute();
const project_id = route.params.project_id;
const tab = route.query.tab;
const rpc = "https://rpc.ankr.com/solana/ae30b80204d212c711b170b40583a8398f3a8f887922a9f15cdccf159de67964"

const blinks = {
  contribute: [
    {
      url: `https://blinks.oxbull.tech/p/${project_id}/oxb-t1/contribute?rpc=${rpc}`,
      cluster: 'mainnet-beta',
      maxButtonPerRow: 2,
      tiers: ['oxb-t1']
    },
    {
      url: `https://blinks.oxbull.tech/p/${project_id}/oxb-t2/contribute?rpc=${rpc}`,
      cluster: 'mainnet-beta',
      maxButtonPerRow: 2,
      tiers: ['oxb-t2']
    },
    {
      url: `https://blinks.oxbull.tech/p/${project_id}/t3/contribute?rpc=${rpc}`,
      cluster: 'mainnet-beta',
      maxButtonPerRow: 2,
      tiers: ['t3']
    },


    {
      url: `https://blinks.oxbull.tech/p/${project_id}/kwai-t1/contribute?rpc=${rpc}`,
      cluster: 'mainnet-beta',
      maxButtonPerRow: 2,
      tiers: ['kwai-t1']
    },
    {
      url: `https://blinks.oxbull.tech/p/${project_id}/kwai-t2/contribute?rpc=${rpc}`,
      cluster: 'mainnet-beta',
      maxButtonPerRow: 2,
      tiers: ['kwai-t2']
    },
    // {
    //   url: 'https://blinks.oxbull.tech/p/oxb/public/contribute',
    //   cluster: 'mainnet-beta',
    //   maxButtonPerRow: 2,
    //   tiers: ['public', 't1', 't2', 't3']
    // }
  ],
  refund: [
    {
      url: `https://blinks.oxbull.tech/p/${project_id}/refund?rpc=${rpc}`,
      cluster: 'mainnet-beta',
      maxButtonPerRow: 2,
      tiers: ['public', 'oxb-t1', 'oxb-t2', 'oxb-t3', 'kwai-t1', 'kwai-t2', 'kwai-t3']
    }
  ],
  vesting: [
    {
      url: `https://blinks.oxbull.tech/p/${project_id}/claim?rpc=${rpc}`,
      cluster: 'mainnet-beta',
      maxButtonPerRow: 2,
      tiers: ['public', 'oxb-t1', 'oxb-t2', 'oxb-t3', 'kwai-t1', 'kwai-t2', 'kwai-t3']
    }
  ],
  immunity: [
    {
      url: `https://blinks.oxbull.tech/p/${project_id}/immunity?rpc=${rpc}`,
      cluster: 'mainnet-beta',
      maxButtonPerRow: 2,
      tiers: ['oxb-t1', 'oxb-t2', 'oxb-t3', 'kwai-t1', 'kwai-t2', 'kwai-t3']
    }
  ]
}

const tabs = ref([
  {
    label: "Contribute",
    key: "contribute",
    selected: false,
  },
  {
    label: "Vesting",
    key: "vesting",
    selected: false,
  },
  {
    label: "Oversub. Refund",
    key: "refund",
    selected: false,
  },
  {
    label: "Immunity Refund",
    key: "immunity",
    selected: false,
  },
  // {
  //   label: "History",
  //   key: "history",
  //   selected: false,
  // },
]);

const renderTabs = () => {
  if (!tab) {
    tabs.value[0].selected = true;
    router.replace({ query: { tab: tabs.value[0].key } });
  } else {
    for (let _tab of tabs.value) {
      if (_tab.key == tab) _tab.selected = true;
      else _tab.selected = false;
    }
  }
};

const selectTab = (_selectedTab) => {
  for (let _tab of tabs.value) {
    _tab.selected = _tab.key == _selectedTab;
  }

  router.replace({ query: { tab: _selectedTab } });
};

const selectedTabKey = computed(() => {
  return tabs.value?.find((_tab) => _tab.selected)?.key;
});

import * as _ from "lodash";

const router = useRouter();

const { $address, $accessToken, $chainId } = useNuxtApp();

const solanaAddress = ref(false)
const tiers = ref('public');

import { createClient } from "@supabase/supabase-js";
const { SUPABASE_KEY, SUPABASE_URL } = useRuntimeConfig().public;
const supabaseUrl = SUPABASE_URL;
const supabaseKey = SUPABASE_KEY;

const computedBlinks = computed(() => {

  let _blinks = _.cloneDeep(blinks);

  for (let key in _blinks) {
    _blinks[key] = _blinks[key].filter((blink) => {
      return tiers.value.some(tier => blink.tiers.includes(tier));
    });
  }


  return _blinks;

});

onMounted(() => {
  renderTabs();
  fetchProject();
  connectSolana()
});


const projectData = ref(null);

const supabaseChannel = ref(null);
const supabaseVestingChannel = ref(null);
const supabase = ref(null);

const fetchProject = async () => {
  // projectData.value = {
  //   info: {
  //     project_banner: "https://picsum.photos/1920/1080",
  //     project_logo: "https://picsum.photos/500/500",
  //     project_name: "Project Name",
  //     project_description: "Project Description",
  //   }
  // }



  let _public_query = gql`
    query getProjectById($project: String) {
      info: getProjectById(target_project_id: $project) {
        project_id
        project_name
        project_description
        project_logo
        project_banner
        project_like
        project_tags
        project_status
        project_symbol
        project_token
        project_preview_date
        project_index
        project_links {
          link_key
          link_url
          link_icon
          link_index
          __typename
        }
        project_writeup_html
        project_writeup_markdown
        is_private
        is_concluded
        is_ushi_private
        is_blink
        is_ino
        __typename
      }
    }
  `;

  
  const gqlResult = await queryNoCache(
    _public_query,
    {
      project: project_id,
    },
    true
  );

    console.log('gqlResult', gqlResult)

    projectData.value = gqlResult


};

const getProvider = () => {
  if ('phantom' in window) {
    const provider = window.phantom?.solana;

    if (provider?.isPhantom) {
      return provider;
    }
  }

  window.open('https://phantom.app/', '_blank');
};

const connectSolana = async () => {

  const provider = getProvider();

  if (provider) {
    try {
      const resp = await provider.connect();
      console.log(resp.publicKey.toString());


      tiers.value = await getTierFromSolanaAddress(resp.publicKey.toString())

      solanaAddress.value = resp.publicKey.toString();
      // 26qv4GCcx98RihuK3c4T6ozB3J7L6VwCuFVc7Ta2A3Uo 
    } catch (err) {
      // { code: 4001, message: 'User rejected the request.' }
    }
  }
}

const { $fetchUser } = useNuxtApp();

const getTierFromSolanaAddress = (solanaAddress) => {
  return new Promise(async (resolve, reject) => {

    const response = await $fetch(`/api/blink/slugs?solana_address=${solanaAddress}&project=${project_id}`)
    console.log(335, response.tiers)

    // resolve('public') // for public
    resolve(response.tiers || ["public"]) // for tier 1
    // resolve('t2') // for tier 2
    // resolve('t3') // for tier 3


  });
}

const disconnectSolana = async () => {
  const provider = getProvider();

  if (provider) {
    try {
      const resp = await provider.disconnect();
      console.log(resp);
      solanaAddress.value = null;
    } catch (err) {
      console.log(err);
    }
  }
}

</script>

<style>
.btn-project-clipped {
  width: 10rem;
  height: 1.8rem;
  border: 0;
  outline: none;
  /* background-color: #000000; */
  cursor: pointer;
  position: relative;
  /* font-size: .85rem; */
  text-transform: uppercase;
  /* color: #000000; */
  clip-path: polygon(0 0, 100% 0, 90% 100%, 10% 100%);
}

.btn-project-clipped__content {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  clip-path: polygon(0 0, 100% 0, 90% 100%, 10% 100%);
}
</style>
